import { render } from "./GroupCreateOrJoin.vue?vue&type=template&id=8e58f4b6&scoped=true&lang=pug"
import script from "./GroupCreateOrJoin.vue?vue&type=script&lang=ts"
export * from "./GroupCreateOrJoin.vue?vue&type=script&lang=ts"

import "./GroupCreateOrJoin.vue?vue&type=style&index=0&id=8e58f4b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e58f4b6"

export default script